import RestaurantRounded from '@mui/icons-material/RestaurantRounded';
import type { ModuleDefinition } from '../types';

export const nutritionModule: ModuleDefinition = {
  key: 'nutrition',
  label: 'Nutrição',
  description: 'Refeições, metas e acompanhamento nutricional.',
  icon: RestaurantRounded,
  nav: [
    {
      to: '/nutricao',
      label: 'Nutrição',
      icon: RestaurantRounded,
      rule: { module: 'nutrition', anyPermission: ['nutrition.self', 'nutrition.clients.read'] },
    },
  ],
  routes: [
    {
      path: '/nutricao',
      lazy: async () => ({ Component: (await import('./pages/NutritionPage')).NutritionPage }),
    },
  ],
};
